import { memo } from 'react';

import JSONIconSVG from '@/assets/json-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IJSONIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={JSONIconSVG} {...props} />;

export const JSONIcon = memo(IJSONIcon) as typeof IJSONIcon;
